import { Config } from "config/config.type"
/** @firescoutMockVar Config.config */
const config:Config = {
  "env": "prod",
  "location": "lusini_pt-pt",
  "shopName": "lusini",
  "locale": "pt-pt",
  "rootCategoryId": "EMG",
  "orderMinimumB2C": 35,
  "availableCreditCards": [
    "MASTERCARD",
    "VISA"
  ],
  "links": {
    "contact": "/ajuda-e-servico/contacto/"
  },
  "i18n": {
    "currency_ISO": "EUR",
    "locale": "pt-PT",
    "country": "PT"
  },
  "languages": {
    "de": "Alemão",
    "en": "Inglês",
    "fr": "Francês",
    "es": "Espanhol",
    "it": "Italiano",
    "nl": "Holandês",
    "pt": "Português",
    "sv": "Sueco",
    "da": "Dinamarquês",
    "nb": "Norueguês",
    "hr": "Croata"
  },
  "slugifyLocale": "pt",
  "hrefLang": [
    {
      "configFolder": "lusini",
      "locale": "pt-pt",
      "hrefLang": "pt"
    }
  ],
  "baseUrl": "https://www.lusini.com",
  "functions": {
    "clientdata": "https://functions.lusini.com/.netlify/functions/clientdata",
    "newsletter": {
      "getOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-getOptInStatus",
      "createContactWithOptIn": "https://functions.lusini.com/.netlify/functions/newsletter-createContactWithOptIn",
      "setOptInStatus": "https://functions.lusini.com/.netlify/functions/newsletter-setOptInStatus"
    },
    "creditsave": {
      "address": "https://functions.lusini.com/.netlify/functions/creditsafe-address"
    },
    "shareCart": {
      "POST": "https://functions.lusini.com/.netlify/functions/shareCart-POST",
      "GET": "https://functions.lusini.com/.netlify/functions/shareCart-GET"
    },
    "raffle": {
      "registration": "https://functions.lusini.com/.netlify/functions/POST-raffle-registration"
    }
  },
  "modules": {
    "onetrust": {
      "dataDomainScript": "bda0c016-94be-4fd9-943a-b9c09791a327"
    },
    "cloudinary": {
      "endpoint": "https://res.cloudinary.com/lusini/",
      "transformations": {
        "freisteller_l": "w_1500,h_1500,q_80,c_pad,f_auto",
        "freisteller_l_2": "w_1500,h_1500,q_80,c_pad,f_auto",
        "milieu_l": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "milieu_l_2": "w_1500,h_1500,g_auto,q_80,c_fill,f_auto",
        "freisteller_m": "w_500,h_500,q_70,c_pad,f_auto",
        "freisteller_m_2": "w_500,h_500,q_70,c_pad,f_auto",
        "milieu_m": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "milieu_m_2": "ws_500,h_500,g_auto,q_70,c_fill,f_auto",
        "freisteller_s": "w_300,h_300,q_70,c_pad,f_auto",
        "freisteller_s_2": "w_600,h_600,q_70,c_pad,f_auto",
        "milieu_s": "w_300,h_300,g_auto,q_70,c_fill,f_auto",
        "milieu_s_2": "w_600,h_600,g_auto,q_70,c_fill,f_auto",
        "freisteller_xs": "w_50,h_50,q_50,c_pad,fl_lossy,f_auto",
        "freisteller_xs_2": "w_100,h_100,q_50,c_pad,fl_lossy,f_auto",
        "milieu_xs": "w_50,h_50,g_auto,q_50,c_fill,fl_lossy,f_auto",
        "milieu_xs_2": "w_100,h_100,g_auto,q_50,c_fill,fl_lossy,f_auto"
      },
      "fallback_product_picture": "https://res.cloudinary.com/lusini/image/upload/v1643182695/application/products/lusini-online-shop-platzhalter-produktbild-in-kuerze-sv.svg",
      "newsletter_intentlayer_picture": "https://res.cloudinary.com/lusini/image/upload/v1724665736/application/NewsletterPopupAB/discount-reduction-pt-pt.svg"
    },
    "shopware": {
      "initialCountryStateId": "d6d885a737d249d0bfec0b63b4be9fb0",
      "initialSaluationId": "6d0b33d96b5b400cbabc648c0a4c3f60",
      "salutations": [],
      "accessKey": {
        "b2b": "SWSC81B5RUYVJF28VKB55VNZXM",
        "b2c": "SWSCX43XSO7EW21IV4ONS9UQN6"
      },
      "storefrontUrl": {
        "b2b": "https://www.lusini.com/pt-pt/b2b",
        "b2c": "https://www.lusini.com/pt-pt/b2c"
      },
      "apiUrl": "https://shop-api.lusini.com/store-api"
    },
    "algolia": {
      "apiKey": "bf4bf9193d5f34cd369647376521dbc8",
      "applicationId": "WAVYBEW6OQ"
    },
    "contentful": {
      "space": "aza65graowyr",
      "environment": "master",
      "accessToken": "CiHQe6Rhx0nDcBT3Siv4qHIUk2xC6CcSwTbtIdMStyk",
      "previewToken": "J9M50p9PZokU9L3-SiDXcfDvVHpcTCzWyLSznbtHPWA"
    },
    "dyHybrid": {
      "apiKey": "e3241f26e68894b7351374710059355e2181541cd5ef10353a15507d5d1e859b",
      "campaignID": "9879543"
    },
    "trustShop": {
      "placeholderImg": "https://res.cloudinary.com/lusini/image/upload/c_scale,w_100/v1670412947/application/icons/trusted-shops-guarantee.svg",
      "id": "XBA945D967976D702EA54D217031C3506w",
      "url": "https://widgets.trustedshops.com/js/",
      "urlPostfix": ".js"
    },
    "zenloop": {
      "id": "WXpnMU1URXpOR010TWpBMU1TMDBZakZtTFdJeU1HTXRaR1kxWkRJek1USmlZV1kw"
    },
    "hotjar": {
      "id": 3549008,
      "version": 6
    },
    "sentry": {
      "active": true,
      "dsn": "https://a8d53cc15046b84787f3f328d54392f6@o4510073018646528.ingest.de.sentry.io/4510073019957328",
      "tracesSampleRate": 1,
      "replaysSessionSampleRate": 0.11,
      "replaysOnErrorSampleRate": 1
    }
  },
  "index": {
    "products": "prod_lusini_pt_PT_products",
    "productsPriceAsc": "prod_lusini_pt_PT_products_priceAsc",
    "productsPriceDesc": "prod_lusini_pt_PT_products_priceDesc",
    "categories": "prod_lusini_pt_PT_categories",
    "series": "prod_lusini_pt_PT_series",
    "productsSuggestion": "prod_lusini_pt_PT_products_query_suggestions",
    "productsLatest": "prod_lusini_pt_PT_products_noveltiesAsc",
    "productReviews": "prod_lusini_product_reviews",
    "serviceReviews": "prod_lusini_service_reviews"
  },
  "deliveryDate": {
    "shippingTooLong": 200
  },
  "colors": {
    "Branco": "white",
    "Preto": "black",
    "Cinza": "grey",
    "Prata": "silver",
    "Castanho": "brown",
    "Azul": "blue",
    "Multicolorido": "multicolor",
    "Vermelho": "red",
    "bege": "beige",
    "Verde": "green",
    "Transparente": "transparent",
    "Amarelo": "yellow",
    "ouro": "gold",
    "Laranja": "orange",
    "Rosa/Lilac": "lilac"
  },
  "features": {
    "devMode": false,
    "trustShop": true,
    "zenloop": true,
    "qrCode": false,
    "b2c": true,
    "b2cHomePage": true,
    "userLikeWidgetUrl": "",
    "notificationBar": true,
    "showNewsletterIntentLayer": true,
    "customizableUrl": "https://www.lusini.com/pt-pt/ajuda-e-servico/servicos/personalizacao/",
    "showCartInfoboxFrom": "2024-12-11T08:00:00",
    "showCartInfoboxTo": "2025-01-10T01:00:00",
    "emarsysWebExtend": true,
    "emarsysWebExtendMerchantId": "1F72DD25D40E8FBF",
    "cmpConsilius3dViewer": {
      "language": "pt"
    }
  },
  "abTests": {},
  "showTelephoneContactOnFailedCheckoutThreshold": 0
}
export default config